import { createElement } from 'react';

/**
 * Creates a new react component with bound properties.
 *
 * @param {Function|Component} component
 * @param {Object} props
 * @returns {ReactElement}
 */
export function bindProps(component, props) {
  return function reboundComponent(newProps) {
    return createElement(component, Object.assign({}, props, newProps));
  };
}
